import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
@Component({
  template: `
  <div [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize : ''" style="display: inline-block;">
    <div class="wrap w-100" [matTooltip]="field.hint" [matTooltipDisabled]="!field.hint"
      matTooltipPosition="above" matTooltipClass="sbm-tooltip">
      <div class="title">
      <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
        {{field.label}}</div>
      <div>{{group.get(field.name).value}}</div>
    </div>
  </div>
`,
  styleUrls: ['./read-only.component.scss']
})
export class ReadOnlyComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() { }
  ngOnInit() { }
}
